import React, { useState, useEffect, useRef } from 'react';
import { arc, interpolate } from 'd3';

const DEIPageDonutChartSlice = ({
  data,
  id,
  isZoomed,
  radius,
}) => {
  const rafRef = useRef();
  const rafTimeRef = useRef();

  const EMPTY_DISPLAY_DATA = {
    startAngle: 0,
    endAngle: 0,
    innerRadius: 50,
    outerRadius: radius,
  }

  const [currentData, setCurrentData] = useState(EMPTY_DISPLAY_DATA);
  const [displayData, setDisplayData] = useState(EMPTY_DISPLAY_DATA);

  const makeArc = arc();

  useEffect(() => {
    const _data = JSON.parse(JSON.stringify(data));

    if (
      _data.startAngle === currentData.startAngle &&
      _data.endAngle === currentData.endAngle
    ) return;

    const startAngleInterpolator = interpolate(currentData.startAngle, _data.startAngle);
    const endAngleInterpolator = interpolate(currentData.endAngle, _data.endAngle);
    const duration = 200;

    const animate = time => {
      // If the animation's start time has been stashed, do the animation
      // otherwise, stash the start time
      if (rafTimeRef.current !== undefined) {
        const timeElapsed = time - rafTimeRef.current;

        // If time elapsed is longer than the intended duration, reset the start time,
        // set the canonical data, and break the animation loop
        if (timeElapsed > duration) {
          rafTimeRef.current = undefined;
          setDisplayData(_data);
          setCurrentData(_data);
          return;
        }

        // Set the animated data using the startAngle and endAngle interpolators
        setDisplayData({
          ...data,
          endAngle: endAngleInterpolator(timeElapsed / duration),
          startAngle: startAngleInterpolator(timeElapsed / duration),
        });

      } else {
        // Stash the start time
        rafTimeRef.current = time;
      }

      // Continue the animation loop
      rafRef.current = window.requestAnimationFrame(animate);
    }

    // Start the animation loop
    rafRef.current = window.requestAnimationFrame(animate);

    // Reset and clear when something changes
    return () => {
      rafTimeRef.current = undefined;
      window.cancelAnimationFrame(rafRef.current);
    }
  }, [data, currentData]);

  return (
    <path
      d={makeArc(displayData)}
      id={id}
      fill="#FFFFFF"
      transform={`translate(${radius}, ${radius})${isZoomed ? ' scale(1.025)' : ''}`}
      style={{ transition: 'transform 0.1s' }}
    />
  )
}

export default DEIPageDonutChartSlice;
